module.exports = __webpack_public_path__ + "img/disclaimer.54eb43e6.png";